import { StripeInvoice } from "../StripeInvoice";

export class MockStripeInvoice implements StripeInvoice {
  private static INDEX = 0;

  uuid: string;
  createdAt: string;
  downloadURL: string;
  name: string;
  previewURL: string;

  constructor() {
    MockStripeInvoice.INDEX++;
    this.uuid = `${MockStripeInvoice.INDEX}`;
    this.createdAt = new Date().toISOString();
    this.downloadURL = `https://download/${this.uuid}`;
    this.previewURL = `https://preview/${this.uuid}`;
    this.name = `name:${this.uuid}`;
  }
}
